import { formatDate } from "@angular/common";

export class Utils {

  public static DateToEnd(date: Date) {
    const tzHours = date.getTimezoneOffset() / 60;
    date.setHours(24 - tzHours - 1, 59, 59);
    // end date will equate to end of utc day and still appear in input as correct day
    // when reversed to a string.
  }
  public static DateInputToEndDate(date_yyyy_mm_dd: string) {
    const dateParts = date_yyyy_mm_dd.split('-');
    const year = '' + dateParts.shift();
    dateParts.push(year);
    const endDate = new Date(dateParts.join('-'));
    Utils.DateToEnd(endDate);

    return endDate;
  }
  public static DateToStart(date: Date) {
    const tzHours = date.getTimezoneOffset() / 60;
    date.setHours(tzHours, 0, 0);
    // start date will equate to start of utc day and still appear in input as correct day
    // when reversed to a string.
  }
  public static DateInputToStartDate(date_yyyy_mm_dd: string) {
    const dateParts = date_yyyy_mm_dd.split('-');
    const year = '' + dateParts.shift();
    dateParts.push(year);
    const startDate = new Date(dateParts.join('-'));
    Utils.DateToStart(startDate);

    return startDate;
  }
  public static UnixtimeToDate(unixtime: number): Date {
    return new Date(unixtime * 1000);
  }
  public static DateToNumber(date: Date) {
    console.log(date.valueOf());
    const dateString = formatDate(date, 'YYYYMMdd', 'en-us');
    console.log(dateString);
    return Number(dateString);
  }

  public static DateToUnixtime(date: Date): number {
    return Math.round(Number(date.valueOf())) / 1000;
  }
  public static GetTreeNode<T>(value: any, src: Array<T>, idField: string = 'id', childrenField = 'children'): T | false {
    for (const node of src) {
      const anyNode:any = node as any;
      if (anyNode[idField] == value) {
        return node;
      }
      if (!!anyNode[childrenField]) {
        if (!!anyNode[childrenField].length) {
          const subNode = Utils.GetTreeNode(value, anyNode[childrenField], idField, childrenField);
          if (!!subNode) return subNode as T;
        }
      }
    }
    return false;
  }
}
